
<template>
  <div>
      <router-view></router-view>
  </div>
</template>

<script>
import api from '@/api/api.js'
import {get, post} from '@/api/index.js'
export default {
  data() {
    return {

    }
  },
  methods: {
    
  },
  components: {

  },
  mounted() {
    // 交付商查询列表
    post(api.deliveryList)
    .then((d) => {
        console.log(d,'交付商')
        if (d.status === 0) {
          var arr = []
          for (let i = 0; i < d.data.length; i++) {
            var obj = {
              value : d.data[i].id,
              label : d.data[i].name,
              divide: d.data[i].businessmenDivide
            }
            arr.push(obj)
          }
          console.log(arr)
          localStorage.setItem('deliveryList',JSON.stringify(arr))
        }
    }, (err) => {
        //error callback
    })
    // 发票内容列表
  },
  created() {
    // deliveryList
    // if (this.$router.history.current.path == '/trading') {
    //   this.$router.push({path: '/trading/capitalAccount'})
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/trading/trading.vue